import React from 'react';
import Styles from './RedButton.css';

function RedButton({ wide, isButton, ...props }) {
  return (
    <>
      {!isButton ? (
        <a href="" {...props} className={`shr-btn-red ${props.className} ${wide ? 'wide' : ''}`} />
      ) : (
        <button {...props} className={`shr-btn-red ${props.className} ${wide ? 'wide' : ''}`} />
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

export default RedButton;
